import { SidebarHeader, SidebarFooter } from '../ui/sidebar'
import { useSession } from '@/providers/SessionProvider'
import { UserTypes } from '@/configs/AppConfig'
import { NavUser } from '../nav-user'
import useNavbar from '@/hooks/use-navbar'
import { Link, useLocation } from 'react-router-dom'

const getFirstSegment = (path) => {
    if (!path) return '/';
    const segments = path.split('?')[0].split('/').filter(Boolean);
    return segments.length > 0 ? `/${segments[0]}` : '/';
};

export const getActiveNavId = (navItems, currentPathname) => {
    const currentSegment = getFirstSegment(currentPathname);
    const activeItem = navItems.find((item) => {
        const itemSegment = getFirstSegment(item.url);
        return itemSegment === currentSegment;
    });
    return activeItem ? activeItem.id : null;
};

export default function Toolbar() {
    const { user, userType, rights } = useSession();
    const { navigation } = useNavbar(userType, rights)
    const location = useLocation();
    const activeId = getActiveNavId(navigation, location.pathname);

    return (
        <div className="z-49 shrink-0 sticky top-0 bg-rose-50/80 backdrop-blur-xl">
            <header className="flex h-20 justify-between items-center px-4 sm:px-6">
                <SidebarHeader className="p-0">
                    <img src="/logo-text.png" className="h-14 w-auto object-contain" alt="Logo" />
                </SidebarHeader>
                <SidebarFooter className="p-0">
                    <NavUser user={user} />
                </SidebarFooter>
            </header>

            {userType === UserTypes.SYSTEM_USER && navigation.length > 0 && (
                <nav className="px-4 sm:px-6">
                    <div className="flex items-center h-10 gap-1 overflow-x-auto scrollbar-none">
                        {navigation.map((item) => {
                            const isActive = item.id === activeId;
                            return (
                                <Link
                                    key={item.id}
                                    to={item.url}
                                    className={`relative flex items-center px-3.5 h-full shrink-0 rounded-full transition-all duration-200 ${
                                        isActive
                                            ? 'bg-white shadow-sm'
                                            : 'hover:bg-white/60 active:bg-white/80'
                                    }`}
                                >
                                    <span className={`text-[13px] whitespace-nowrap transition-colors ${
                                        isActive
                                            ? 'text-primary font-semibold'
                                            : 'text-slate-600 font-medium'
                                    }`}>
                                        {item.title}
                                    </span>
                                </Link>
                            );
                        })}
                    </div>
                </nav>
            )}

            <div className="h-px bg-rose-200/40" />
        </div>
    )
}
